'use strict';

import $ from 'jquery';
import config from '../../js/config';
import template from './ReadMore.hbs';


export default class ReadMore {
  constructor(el) {
    this.el = el;
    this.$el = $(el);
    this.initialize();
  }

  initialize() {
    this.$title = $('h1').find('.u-middle').html();
    this.$content = this.$el.find('.ReadMore-content');
    this.$container = $(template({
      more: this.$el.data('moreText'),
      less: this.$el.data('lessText'),
      content: this.$content.html()
    }));
    this.$content.replaceWith(this.$container);
    this.$toggle = this.$container.find('.ReadMore-toggle');
    this.$toggle.attr('aria-label','Read More about ' + this.$title);

    this.$toggle.on('click', this.onToggle.bind(this));
  }

  onToggle(e) {
    e.preventDefault();
    this.$container.toggleClass(config.classes.isOpen);
    var $readMoreContainer = $('div').find('.ReadMore-container')
    if ($readMoreContainer.hasClass('is-open'))
    {
      this.$toggle.attr('aria-label','Read Less about ' + this.$title);
    }
    else {
      this.$toggle.attr('aria-label','Read More about ' + this.$title);
    }
  }
}

export function create($parent) {
  $parent.find('.ReadMore').each((n, el) => new ReadMore(el));
}



// WEBPACK FOOTER //
// ./assets/components/ReadMore/ReadMore.js